import { render, staticRenderFns } from "./SearchIAToolbarComponent.vue?vue&type=template&id=576b3ed3&scoped=true"
import script from "./SearchIAToolbarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchIAToolbarComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchIAToolbarComponent.vue?vue&type=style&index=0&id=576b3ed3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576b3ed3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('576b3ed3')) {
      api.createRecord('576b3ed3', component.options)
    } else {
      api.reload('576b3ed3', component.options)
    }
    module.hot.accept("./SearchIAToolbarComponent.vue?vue&type=template&id=576b3ed3&scoped=true", function () {
      api.rerender('576b3ed3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIAToolbarComponent.vue"
export default component.exports